import Header from "../components/Header";
import Footer from "../components/Footer";
import ChatBot from "../components/ChatBot";
import HomeSteps from "./home/HomeSteps"
import HomePractice from "./home/HomePractice"
import HomeWhyChoose from "./home/HomeWhyChoose";
import HomeBlogs from "./home/HomeBlogs";
import NeedLegalAssistance from "./home/NeedLegalAssistance";
import "../styles/Home.css";
import { useNavigate } from "react-router-dom";

export default function Home() {
  const navigate = useNavigate();

  return (
    <>
      <Header />

      <main className="hero-home">
        {/* HERO SECTION */}
        <section className="hero-section">
          <div className="hero-content">
            <span className="hero-tagline">GET FIERCE LEGAL SUPPORT</span>

            <h1>
              Find the Right <br />
              <span>Legal Expert</span>, fast
            </h1>

            <p>
              Connect with top-rated solicitors for your legal needs.
              Verified professionals, transparent pricing, and instant booking.
            </p>

            <button
              className="ctaBtn"
              onClick={() => navigate("/search")}
            >
              Get Started
            </button>
          </div>

          <div className="hero-image">
            <img src="/Home/hero.png" alt="Lady Justice" />
          </div>
        </section>

        {/* STATS SECTION */}
        <section className="hero-stats">
          <div className="stat-item">
            <img src="/Home/i1.png" alt="Solicitors" />
            <h3>12k+</h3>
            <p>SOLICITORS</p>
          </div>

          <span className="divider" />

          <div className="stat-item">
            <img src="/Home/i2.png" alt="Cases Solved" />
            <h3>50k+</h3>
            <p>CASES SOLVED</p>
          </div>

          <span className="divider" />

          <div className="stat-item">
            <img src="/Home/i3.png" alt="User Rating" />
            <h3>4.9/5</h3>
            <p>USER RATING</p>
          </div>

          <span className="divider" />

          <div className="stat-item">
            <img src="/Home/i4.png" alt="Support" />
            <h3>24/7</h3>
            <p>SUPPORT</p>
          </div>
        </section>
      </main>

      {/* <HomeSections/> */}

      <HomeSteps />
      <HomePractice />
      <HomeWhyChoose />
      <div className="home-cta-wrapper">
        <HomeBlogs />
      </div>
      <div className="home-cta-wrapper">
        <NeedLegalAssistance />
      </div>
      <ChatBot />
      <Footer />
    </>
  );
}
